@if (!verifiedCountry) {
  <div class="country">
    <span class="country-label">Countries</span>
    <span class="country-value">{{ countries && countries.length ? countries.join(', ') : '' }}</span>
  </div>
} @else {
  <div class="country">
    <span class="country-label">Verified Country</span>
    <span class="country-value">{{ verifiedCountry }}</span>
  </div>
}
